import { z } from "zod/v4";

import {
  RedirectDtoDescriptions,
  RedirectQueryParamDtoDescriptions,
} from "../descriptions/redirect-dto.describe";
import { assertDescriptions } from "../descriptions/types";

import { ShopifyTemplateType } from "./shopify";

export const RedirectQueryParamDtoSchema = z.object({
  key: z.string().describe(RedirectQueryParamDtoDescriptions.key),
  value: z.string().describe(RedirectQueryParamDtoDescriptions.value),
});

export type RedirectQueryParamDto = z.infer<typeof RedirectQueryParamDtoSchema>;

export const RedirectFilterList = [
  "matchesExactly",
  "contains",
  "endsWith",
  "matchesRegex",
  "none",
] as const;
export type RedirectFilter = (typeof RedirectFilterList)[number];

export const UrlRedirectTypeList = [
  "fullReplacement",
  "partialReplacement",
] as const;
export type UrlRedirectType = (typeof UrlRedirectTypeList)[number];

export const RedirectDtoSchema = z.object({
  id: z.uuid().describe(RedirectDtoDescriptions.id),
  group: z.number().describe(RedirectDtoDescriptions.group),
  variationId: z.uuid().describe(RedirectDtoDescriptions.variationId),
  originUrl: z.string().describe(RedirectDtoDescriptions.originUrl),
  destinationUrl: z
    .string()
    .nullish()
    .describe(RedirectDtoDescriptions.destinationUrl),
  queryParams: RedirectQueryParamDtoSchema.array()
    .default([])
    .describe(RedirectDtoDescriptions.queryParams),
  skip: z.boolean().describe(RedirectDtoDescriptions.skip),
  isThemeTest: z.boolean().describe(RedirectDtoDescriptions.isThemeTest),
  isTemplateTest: z.boolean().describe(RedirectDtoDescriptions.isTemplateTest),
  templateType: z
    .enum(ShopifyTemplateType)
    .nullish()
    .describe(RedirectDtoDescriptions.templateType),
  templateSuffixes: z
    .string()
    .array()
    .nullish()
    .default([])
    .describe(RedirectDtoDescriptions.templateSuffixes),
  redirectOnce: z
    .boolean()
    .default(false)
    .describe(RedirectDtoDescriptions.redirectOnce),
  filter: z
    .enum(RedirectFilterList)
    .default("matchesExactly")
    .describe(RedirectDtoDescriptions.filter),
  find: z.string().nullish().describe(RedirectDtoDescriptions.find),
  redirectType: z
    .enum(UrlRedirectTypeList)
    .default("fullReplacement")
    .describe(RedirectDtoDescriptions.redirectType),
});

export type RedirectDto = z.infer<typeof RedirectDtoSchema>;

// Compile-time checks: description objects must cover all schema keys
assertDescriptions<
  typeof RedirectQueryParamDtoDescriptions,
  RedirectQueryParamDto
>();
assertDescriptions<typeof RedirectDtoDescriptions, RedirectDto>();
